import { PrimaryButton } from '@fluentui/react';
import { useState } from 'react';
import { WorkgroupGroupsViewModal } from './WorkgroupGroupsViewModal';

export const WorkgroupGroupsView = () => {
  
  const [visible, setVisible] = useState(false);

  const _onClick = () => {
    setVisible(true);
  };

  return (
    <>
      <PrimaryButton
        iconProps={{
          iconName: 'Add',
        }}
        text="New Group"
        onClick={_onClick}
      />
      <WorkgroupGroupsViewModal
        isOpen={visible}
        isEdit={false}
        onClose={() => setVisible(false)}
      />
    </>
  );
};
